const Log = require('./Log');
const LogStore = require('./destination/LogStore');
const ConsoleLog = require('./destination/ConsoleLog');
const Utils = require('./Utils');

const fell = new Log();
fell.destination = {
  LogStore,
  ConsoleLog,
  Utils,
};
fell.Log = fell;

module.exports = fell;
